'use client';
import { Logo } from '../Logo';
import { Button } from '../button';
import { NavBarItem } from './navbar-item';
import { useMotionValueEvent, useScroll } from 'framer-motion';
import { cn, shouldShowSignUp } from '@/lib/utils';
import { useEffect, useState } from 'react';
import { LanguageSelector } from './LanguageSelector';
import { useTranslation } from 'react-i18next';

type Props = {
  navItems: {
    link: string;
    title: string;
    target?: '_blank';
  }[];
  landingMode?: boolean;
};

export const DesktopNavbar = ({ navItems, landingMode = false }: Props) => {
  const { t } = useTranslation('common');
  const [showBackground, setShowBackground] = useState(false);
  const showSignUp = shouldShowSignUp();

  // Use window-level scroll with proper options
  // Using a more reliable approach without explicitly targeting elements
  const { scrollY } = useScroll({
    // Don't specify a target to use the viewport as default
    // This avoids the hydration warning
    offset: ['start start', 'end end'],
    layoutEffect: false, // Must be false to prevent hydration issues
    container: false, // Use the viewport as a container
  });

  // Enhanced scroll handling with better performance
  useMotionValueEvent(scrollY, 'change', value => {
    if (value > 100) {
      setShowBackground(true);
    } else {
      setShowBackground(false);
    }
  });

  // Initialize background state based on current scroll position on mount
  useEffect(() => {
    const checkInitialScroll = () => {
      if (window.scrollY > 100) {
        setShowBackground(true);
      }
    };

    // Check immediately
    checkInitialScroll();

    // Add a scroll listener as a backup in case framer-motion's useScroll misses events
    window.addEventListener('scroll', checkInitialScroll);

    return () => {
      window.removeEventListener('scroll', checkInitialScroll);
    };
  }, []);
  return (
    <div
      className={cn(
        'w-full flex relative justify-between px-4 py-2 rounded-full bg-transparent transition duration-200',
        showBackground &&
          'bg-[#F5F5F5] dark:bg-neutral-900 shadow-[0px_-2px_0px_0px_var(--neutral-100),0px_2px_0px_0px_var(--neutral-100)] dark:shadow-[0px_-2px_0px_0px_var(--neutral-800),0px_2px_0px_0px_var(--neutral-800)]'
      )}
    >
      {/*<AnimatePresence>*/}
      {/*    {showBackground && (*/}
      {/*        <motion.div*/}
      {/*            key={String(showBackground)}*/}
      {/*            initial={{opacity: 0}}*/}
      {/*            animate={{opacity: 1}}*/}
      {/*            transition={{*/}
      {/*                duration: 1,*/}
      {/*            }}*/}
      {/*            className="absolute inset-0 h-full w-full bg-[#F5F5F5] dark:bg-neutral-800 pointer-events-none [mask-image:linear-gradient(to_bottom,white,transparent,white)] rounded-full"*/}
      {/*        />*/}
      {/*    )}*/}
      {/*</AnimatePresence>*/}
      <div className="flex flex-row gap-2 items-center">
        <Logo />
        <div className="flex items-center gap-1.5">
          {navItems.map(item => (
            <NavBarItem href={item.link} key={item.title} target={item.target}>
              {item.title}
            </NavBarItem>
          ))}
        </div>
      </div>
      <div className="flex space-x-2 items-center">
        {!landingMode && (
          <>
            <LanguageSelector />
            <Button variant="simple" href="https://app.verdea.app/login/">
              {t('nav.login')}
            </Button>
            {showSignUp && <Button to="/signup">{t('nav.signup')}</Button>}
          </>
        )}
      </div>
    </div>
  );
};
